import { Link } from 'react-router-dom';

import { useGetVesselsGeoInfoMutation } from 'app/api/facade';

import styles from 'app/pages/FleetPage/Fleet.module.scss';

interface PortCellProps {
  mmsi: number;
}

export const PortCell = ({ mmsi }: PortCellProps) => {
  const [, { data }] = useGetVesselsGeoInfoMutation({
    fixedCacheKey: 'get-port-mutation',
  });

  const vesselPort = data?.results?.find((ship) => ship.key === mmsi.toString())?.inPort;

  if (!vesselPort || typeof vesselPort.name !== 'string') {
    return <>&mdash;</>;
  }

  return typeof vesselPort.key === 'string' ? (
    <Link to={`/ports/${vesselPort.key}`} className={styles.link}>
      {vesselPort.name}
    </Link>
  ) : (
    <>{vesselPort.name}</>
  );
};
